import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusIndicatorComponent } from './status-indicator.component';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from '@uw/shared/material.module';

@NgModule({
    imports: [CommonModule, TranslateModule, AngularMaterialModule, StatusIndicatorComponent],
    exports: [StatusIndicatorComponent],
})
export class StatusIndicatorModule {}
